import {ChatForm as Form} from './Form';
import {Message} from './Message';
import {Messages} from './Messages';

export const Chat = {
    Form,
    Message,
    Messages,
}